import {
  HIVE_FRAME_PANEL_BODY,
  FramePanelBody,
} from './body/frame-panel-body';
import { HIVE_FRAME_CARD, FrameCard } from './card/frame-card';
import {
  HIVE_FRAME_CARD_TITLE,
  FrameCardTitle,
} from './card/frame-card-title';
import {
  HIVE_FRAME_TITLE_EDITOR,
  FrameCardTitleEditor,
} from './card/frame-card-title-editor';
import { HIVE_FRAME_PREVIEW, FramePreview } from './card/frame-preview';
import { HIVE_FRAME_PANEL, FramePanel } from './frame-panel';
import {
  HIVE_FRAME_PANEL_HEADER,
  FramePanelHeader,
} from './header/frame-panel-header';
import {
  HIVE_FRAMES_SETTING_MENU,
  FramesSettingMenu,
} from './header/frames-setting-menu';

export function effects() {
  customElements.define(HIVE_FRAME_PANEL, FramePanel);
  customElements.define(HIVE_FRAME_TITLE_EDITOR, FrameCardTitleEditor);
  customElements.define(HIVE_FRAME_CARD, FrameCard);
  customElements.define(HIVE_FRAME_CARD_TITLE, FrameCardTitle);
  customElements.define(HIVE_FRAME_PANEL_BODY, FramePanelBody);
  customElements.define(HIVE_FRAME_PANEL_HEADER, FramePanelHeader);
  customElements.define(HIVE_FRAMES_SETTING_MENU, FramesSettingMenu);
  customElements.define(HIVE_FRAME_PREVIEW, FramePreview);
}
